var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fip-promo"},[(_vm.bannerDefinition && !_vm.hasTicketVideo)?_c('banner-promo',{staticClass:"bandeau-flexivod",attrs:{"promo":_vm.bannerDefinition}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }